import { ToastContainerProps } from "react-toastify";

const settings: ToastContainerProps = {
  position: "top-left",
  hideProgressBar: true, // проще отключить, чем прогресс null
  autoClose: 3000,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
  closeButton: false,
  newestOnTop: false,
  rtl: false,
  limit: 3,
  theme: "light",
  style: {
    padding: "0.5rem 0",
    top: "4rem",
    left: "var(--boundary-offset-x)",
  },
  bodyStyle: {
    padding: 0,
    margin: 0,
    height: "fit-content",
  },
  toastStyle: {
    background: "transparent",
    boxShadow: "none",
    width: "20rem",
    marginBottom: "0.4rem",
    height: "fit-content",
    minHeight: "fit-content",
    padding: 0,
  },
};

export default settings;
